import { render, staticRenderFns } from "./StateParent.vue?vue&type=template&id=0338bed5&scoped=true&"
import script from "./StateParent.vue?vue&type=script&lang=js&"
export * from "./StateParent.vue?vue&type=script&lang=js&"
import style0 from "./StateParent.vue?vue&type=style&index=0&id=0338bed5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0338bed5",
  null
  
)

export default component.exports